import type { FaireProductEntity } from "../../entity_types/product";

export const p_jvdvzeuj9e: FaireProductEntity = {
  token: "p_jvdvzeuj9e",
  type: "product",
  name: "On Gamedays We Wear",
  brandToken: "b_stzes6vr2c",
  brandName: "Al + Gray Graphic Tees",
  imageUrl:
    "https://cdn.faire.com/fastly/c76e45ffb3e224304ce8d482c5918e1902fde10d676f99760e76709a189a596a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee9af349a0f4574c3b17031589aed2fb29c83dc73df77a7c3ca2137adcaecdb0.png",
    "https://cdn.faire.com/fastly/acb88ffe5286fa55ec2e7811bd399fcd57dc1d7dbb6e288644e52f340eca2bfa.png",
    "https://cdn.faire.com/fastly/11e592a2e0499f5ced20f80bc10f3b4269482106d676871c4cf010539672e69b.png",
    "https://cdn.faire.com/fastly/1f79b8d81ffce3801c5b3f17ce08226b9495f980a070b67d59c1936d9bdb6f44.png",
  ],
  priceDollars: 16.5,
  description:
    'Show your team spirit in style with this cozy sweatshirt featuring the bold phrase "On Gamedays we wear red" and a charming bow on the front. Perfect for game day!\n\n * Gildan • Crewneck Sweatshirt • Cotton/Poly \n * Gildan • Short Sleeve Tee \n * Use guide included below for options! \n * White Ink Colors - DTF Custom Print \n\n\n * Youth Sweatshirt Color Options: Red, Royal, Navy & Black \n * Youth Tees Color Options are available in all colors listed. \n\nCUSTOM\nLooking for your school color? We can do it!\n * Color of Tee or Sweatshirt (ex. Red) \n\n',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:55.916Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
